// Borrowed some stuff from: http://stackoverflow.com/questions/23302488/mvc-client-side-validation-for-phoneattribute

(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('input', phoneInputDirective);

    var rReversePhone = new RegExp("^(\\d+\\s?(x|\\.txe?)\\s?)?((\\)(\\d+[\\s\\-\\.]?)?\\d+\\(|\\d+)[\\s\\-\\.]?)*(\\)([\\s\\-\\.]?\\d+)?\\d+\\+?\\((?!\\+.*)|\\d+)(\\s?\\+)?$", "i");

    phoneInputDirective.$inject = ['$parse'];
    function phoneInputDirective($parse) {
        return {
            restrict: 'E',
            require: ['?ngModel'],
            link: link
        };

        function link(scope, element, attr, ctrl) {
            ctrl = ctrl[0];
            if (ctrl && attr.type && attr.type.toLowerCase() === 'tel') 
                ctrl.$validators.tel = validatePhoneNumber;

            function validatePhoneNumber(modelValue, viewValue) {
                var value = modelValue || viewValue;
                if (ctrl.$isEmpty(value))
                    return true;

                var reverseValue = value.split("").reverse().join("");
                var match = rReversePhone.exec(reverseValue);
                return (match && (match.index === 0) && (match[0].length === value.length));
            };
        }
    }
})();
